// src/pages/InfluencerJoin.js
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './InfluencerJoin.css';

const SERVICE_ID   = 'service_rkd3nje';   // <-- paste your actual EmailJS Service ID
const TEMPLATE_ID  = 'template_qn0p4ab';  // <-- paste your actual EmailJS Template ID
const PUBLIC_KEY   = 'jb85tG8nJgXDnDBVa';   // <-- paste your actual EmailJS Public Key

export default function InfluencerJoin() {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [showThanks, setShowThanks] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formRef.current) return;
    setSending(true);

    try {
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, {
        publicKey: PUBLIC_KEY,
      });
      setShowThanks(true);
      formRef.current.reset(); // clear form
    } catch (err) {
      console.error('EmailJS error:', err);
      alert('Sorry, something went wrong while sending. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="influencer-page"
      style={{
        backgroundImage: "url('/influencer-form-bg.jpg')", // keep this in /public
      }}
    >
      <div className="influencer-overlay" />

      <div className="influencer-card">
        <h1 className="influencer-title">🌍 Join as a Travel Influencer</h1>
        <p className="influencer-sub">
          Tell us about you and the kind of collaborations you’re interested in.
        </p>

        <form ref={formRef} className="influencer-form" onSubmit={handleSubmit}>
          {/* Name */}
          <label>
            Your Name
            <input type="text" name="name" placeholder="John / Jane Doe" required />
          </label>

          {/* Handle */}
          <label>
            Instagram / YouTube Handle
            <input type="text" name="instagram" placeholder="@yourhandle" required />
          </label>

          {/* Email */}
          <label>
            Email Address
            <input type="email" name="email" placeholder="you@example.com" required />
          </label>

          {/* Niche */}
          <label>
            Niche (e.g., Luxury, Adventure, Food, Family)
            <input type="text" name="niche" placeholder="Adventure + Drone shoots" />
          </label>

          {/* Followers */}
          <label>
            Number of Followers / Subscribers
            <input type="number" name="followers" placeholder="e.g., 120000" required />
          </label>

          {/* Interested In */}
          <label>
            Interested In
            <select name="interestedIn" required defaultValue="">
              <option value="" disabled>Choose an option</option>
              <option value="hotel-collabs">Hotel Collaborations</option>
              <option value="brand-campaigns">Brand Campaigns</option>
              <option value="hosted-stays">Hosted Stays</option>
              <option value="content-creation">Content Creation</option>
              <option value="all">All of the above</option>
            </select>
          </label>

          {/* Bio */}
          <label>
            Tell us about your travel content
            <textarea
              name="bio"
              rows="4"
              placeholder="Your audience, destinations, recent brand work, etc."
            />
          </label>

          {/* Optional hidden fields */}
          <input type="hidden" name="source" value="Influencer Join Page" />
          <input type="hidden" name="timestamp" value={new Date().toISOString()} />

          <button type="submit" disabled={sending}>
            {sending ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>

      {/* Thank-you popup */}
      {showThanks && (
        <div className="thanks-backdrop" onClick={() => setShowThanks(false)}>
          <div className="thanks-modal" onClick={(e) => e.stopPropagation()}>
            <div className="check">✅</div>
            <h3>Thank you!</h3>
            <p>We’ve received your details. Our team will contact you shortly.</p>
            <button onClick={() => setShowThanks(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
